<template lang="html">
  <div id="live-chat">
		<div class="chat">
      <div>
        <button class="btn btn-link" @click="viewComments">Kommentare anzeigen ({{ nameRef.totalComment }})</button>
      </div>
			<div class="chat-history" v-if="showComments">
        <form @submit.prevent>
  				<fieldset>
  					<input type="text" placeholder="Kommentar schreiben..." v-model="commentMsg" autofocus>
            <button class="btn" @click.prevent="comment">Kommentieren</button>
  				</fieldset>
  			</form>
        <hr>
        <ChatMessage
          v-for="comment in sortedComments"
          :key="comment['.key']"
          :message="comment.comment"
          :userName="comment.user"
          :datum="comment.dateTime"
          >
        </ChatMessage>
			</div> <!-- end chat-history -->
		</div> <!-- end chat -->
	</div> <!-- end live-chat -->
</template>

<script>
import ChatMessage from './ChatMessage.vue'
import Names from '../models/names'

import { db } from '../firebase'

const sorting = commentsArray => commentsArray.reverse()

export default {
  components: {
    ChatMessage,
  },
  props: ['addComment', 'nameRef'],
  data() {
    return {
      commentMsg: '',
      showComments: false,
      comments: [],
    }
  },
  computed: {
    sortedComments() {
      return sorting(this.comments)
    },
  },
  methods: {
    comment: function() {
      this.addComment(this.nameRef['.key'], this.commentMsg)
      this.commentMsg = ''
    },
    toggleComments: function() {
      return this.showComments = !this.showComments
    },
    viewComments: function () {
      this.$bindAsArray('comments', db().ref('comment/' + this.nameRef['.key']).orderByValue().limitToLast(25))
      this.toggleComments()
    }
  },

}
</script>

<style lang="css" scoped>
/* ---------- LIVE-CHAT ---------- */


#live-chat input[type="text"] {
	border: 1px solid #ccc;
	border-radius: 3px;
	padding: 8px;
	outline: none;
	width: 234px;
}


.chat-history {
	height: 252px;
	padding: 8px 24px;
	overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// Chat.vue?b6abb6ca